// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Color, Mesh, Object3D } from 'three'

//sets yellow gold color by default, due a bug in draco loader
export function parseDemoRingV2(jewelryModel: Object3D) {
  jewelryModel.children[0].children.forEach((mesh) => {
    if ((mesh as Mesh).material.name === 'metal') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
      mesh.material.color.set(new Color('#FFB645'))
    }
  })

  return jewelryModel
}
